import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, NavigationExtras, Navigation } from '@angular/router';

@Component({
	selector: 'app-season-bag-new-modal',
	templateUrl: './season-bag-new-modal.component.html',
	styleUrls: ['./season-bag-new-modal.component.scss'],
})
export class SeasonBagNewModalComponent {
	data = {
		id: 'add',
		name: null,
		side: null,
		transportexist: false,
		destinationStop: null,
		destinationDate: null,
		seasons: [],
	};
	constructor(
		private readonly router: Router,
		private readonly dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public season: any,
	) {}

	transport(side) {
		this.data.side = side;
		this.data.name = this.season.name;
		this.data.seasons = this.season.id;
		this.data.destinationStop = this.season.transportStop.id;
		if (side == 'departure') {
			if (this.season.transportDeparture !== null) {
				this.data.id = this.season.transportDeparture.id;
			}
			this.data.destinationDate = this.season.accommodation.lower;
		} else {
			if (this.season.transportReturn !== null) {
				this.data.id = this.season.transportReturn.id;
			}
			this.data.destinationDate = this.season.accommodation.upper;
		}
		if (this.data.id == null) {
			this.data.id = 'add';
		}
		// jak zrobić aby można było otwierać to w nowym oknie ?
		// Pass data for queryParams
		const passedData: NavigationExtras = {
			queryParams: this.data,
		};

		this.router.navigate(['transport/transport/' + this.data.id, this.data]);
		this.dialogRef.close(true);
	}
}
